import { init as initApm } from '@elastic/apm-rum'

const active = parseInt(process.env.ELASTIC_RUM_ACTIVE || '0')

const apmConfig = {
  active: isNaN(active) === false ? Math.random() < active : false,

  breakdownMetrics: '1' === process.env.ELASTIC_RUM_BREAKDOWN_METRICS,
  distributedTracing: '1' === process.env.ELASTIC_RUM_DISTRIBUTED_TRACING,
  distributedTracingOrigins: (process.env.ELASTIC_RUM_DISTRIBUTED_TRACING_ORIGINS || '').split(','),
  environment: process.env.ELASTIC_RUM_ENVIRONMENT,
  propagateTracestate: '1' === process.env.ELASTIC_RUM_PROPAGATE_TRACESTATE,
  serverUrl: process.env.ELASTIC_RUM_SERVER_URL,
  serviceName: process.env.ELASTIC_RUM_SERVICE_NAME
}

initApm(apmConfig)



// WEBPACK FOOTER //
// ./rum/rum.js